export default {"src":"/_next/static/media/ic_phone.8499d62f.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};